.container {
    container-name: custom-field-list;
    container-type: inline-size;
    width: 100%;
}

.grid {
    display: grid;
    width: 100%;
    grid-template-columns: repeat(2, 1fr);
}

.grid-1-column {
    display: grid;
    width: 100%;
    grid-template-columns: 1fr;
}

.grid-2-column {
    display: grid;
    width: 100%;
    grid-template-columns: repeat(2, 1fr);
}

.column {
    display: flex;
    flex-direction: column;
    width: 100%;
}

@container custom-field-list (width > 601px) {
    .grid {
        grid-template-columns: repeat(3, 1fr);
    }
}
